import { LinkButton } from "components/controls/LinkButton";
import ActionResponseErrorBoundary from "components/layout/ErrorBoundary/components/ActionResponseErrorBoundary";
import { ActionError } from "modules/errors"
import { useHistory } from "react-router-dom";
import { issuesManagementHome } from "sections/issues-management";


const IssueForbidden = () => {

    const history = useHistory();

    const error: ActionError<string> = {
        message: 'You do not have permission to view this Issue'
    } 

    const returnToIssueList = (): void => {
        history.push(issuesManagementHome)
    }

    return (
        <ActionResponseErrorBoundary error={error}>
            Click <LinkButton text="Here" onClick={returnToIssueList} /> to return to the Issue management page
        </ActionResponseErrorBoundary>
    )
};

export default IssueForbidden;